import axios from "../axiosInstance";
import { handleApiResponse } from "../utils";

export const fetchNutrSpecLists = async ({ queryKey }) => {
 const [_, params] = queryKey;

 const url = `/fft/v2/nutritional-spec-list`;
 const response = handleApiResponse(async () => {
  return axios.get(url, { params });
 });

 return response;
};

export const fetchNutrSpecList = nutrSpecListId => {
 const url = `/fft/v2/nutritional-spec-list/${nutrSpecListId}`;
 return handleApiResponse(() => {
  return axios.get(url);
 });
};

export const updateNutrSpecs = (recipeListId, requestBody) =>
 handleApiResponse(
  () => axios.put(`/fft/v2/nutritional-spec-list/${recipeListId}/nutritional-specs`, requestBody),
  "Nutritional spec list updated successfully",
 );

export const checkNameExists = async (name) => {
 const encodedName = encodeURIComponent(name.trim());
 const url = `/fft/v2/nutritional-spec-list/check-name/${encodedName}`;
 return handleApiResponse(() => {
  return axios.get(url);
 });
};

export const createNutrSpecList = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/nutritional-spec-list`, requestBody), "Nutritional spec list created successfully");

export const createNutrSpecListCopy = (listId, requestBody) =>
 handleApiResponse(() => axios.post(`/fft/v2/nutritional-spec-list/${listId}/copy`, requestBody), "Nutritional spec list copied successfully");

export const deleteNutritionalSpecList = listId =>
 handleApiResponse(() => axios.delete(`/fft/v2/nutritional-spec-list/${listId}`), "Nutritional spec list deleted successfully");

export const updateNutritionalSpecList = (listId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/nutritional-spec-list/${listId}`, requestBody), "Nutritional spec list updated successfully");

export const syncNutritionalSpecs = listId =>
 handleApiResponse(() => axios.post(`/fft/v2/nutritional-spec-list/${listId}/sync`), "Nutritional spec list synced successfully");
